/** Normalisiert Warenkorb-Mengen (z. B. nach localStorage-Load als String). */
export function getCartItemQuantity(quantity) {
    const qty = Number(quantity);
    return Number.isFinite(qty) && qty > 0 ? Math.floor(qty) : 1;
}
/** Mülleimer bei Menge 1, sonst Minus — Warenkorb, Sidebar und Checkout. */
export function shouldShowCartTrashIcon(quantity) {
    return getCartItemQuantity(quantity) === 1;
}
